import { v4 as uuid } from 'uuid';
import configJSON from 'config.json';
import storage from 'utils/storage';
import { isEndToEndTest } from './environment';

export default function creaAnalytics(listingId:number, creaUrl: string | null) {
  if (isEndToEndTest) return;
  
  if (configJSON.host !== 'http://localhost:4200' && configJSON.host !== 'https://stage.zoocasa.com' && !/\.t\.zoocasa\.com$/.test(configJSON.host)) {
    const creaListingId = creaUrl?.replace('https://www.realtor.ca/real-estate', '').split('/')[1];
    if (creaListingId) {
      fetch(`https://analytics.crea.ca/LogEvents.svc/LogEvents?ListingID=${creaListingId}&DestinationID=35&EventType=view&UUID=${getUUID()}`).catch();
    } else {
      console.error(`CREA listing id not found for Zoocasa listing ${listingId}`);
    }
  }
}

const getUUID = () => {
  const UUID = storage.get('crea-uuid');
  if (!UUID) {
    const createdUUID = uuid();
    storage.set('crea-uuid', createdUUID);
    return createdUUID;
  }
  return UUID;
};
